import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeStyle as _normalizeStyle, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-13aa26ba"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["innerHTML"]
const _hoisted_2 = { class: "title" }
const _hoisted_3 = ["title"]
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  class: "icon",
  width: "32px",
  height: "32px",
  viewBox: "0 0 1280 1024",
  version: "1.1",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    fill: "#777",
    d: "M256 256h768v512H256zM128 320H0V64a64 64 0 0 1 64-64h256v128H128zM1280 320h-128V128h-192V0h256a64 64 0 0 1 64 64zM320 1024H64a64 64 0 0 1-64-64v-256h128v192h192zM1216 1024h-256v-128h192v-192h128v256a64 64 0 0 1-64 64z"
  })
], -1))
const _hoisted_5 = [
  _hoisted_4
]
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "popup-content" }, [
  /*#__PURE__*/_createElementVNode("p", null, "这里是浮动层的内容")
], -1))
const _hoisted_7 = [
  _hoisted_6
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_ctx.showCanvas)
    ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: "canvas-container",
        onWheel: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.handleWheel && _ctx.handleWheel(...args))),
        onMousedown: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.startPan && _ctx.startPan(...args))),
        onTouchstart: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.handleTouchStart && _ctx.handleTouchStart(...args))),
        onTouchmove: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.handleTouchMove && _ctx.handleTouchMove(...args))),
        onTouchend: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.handleTouchEnd && _ctx.handleTouchEnd(...args))),
        onClick: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.showPopupAtClick && _ctx.showPopupAtClick(...args)))
      }, [
        _createElementVNode("div", {
          ref: "svgContainer",
          class: "svg-content",
          innerHTML: _ctx.svgContent
        }, null, 8, _hoisted_1),
        _createElementVNode("div", _hoisted_2, _toDisplayString(_ctx.svgTitle), 1),
        _createElementVNode("div", {
          class: "zoomFit",
          title: _ctx.t('operation.fitScreen'),
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.resetDiagram && _ctx.resetDiagram(...args)))
        }, _hoisted_5, 8, _hoisted_3),
        (_ctx.showPopup)
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              class: "popup",
              style: _normalizeStyle(_ctx.popupPosition)
            }, _hoisted_7, 4))
          : _createCommentVNode("", true)
      ], 32))
    : _createCommentVNode("", true)
}